<template>
    <BaseModal :title="$t('title')" v-on="$listeners">
        <BaseCard padded>
            <ChangePasswordForm
                ref="form"
                @disabled="isDisabled = $event"
                @loading="isLoading = $event"
            />
        </BaseCard>

        <template #footer>
            <div class="l-inline l-justify-end">
                <BaseButton
                    size="small"
                    :disabled="isDisabled"
                    :is-loading="isLoading"
                    @click="handleSubmit"
                >
                    {{ $t('shared.save') }}
                </BaseButton>
            </div>
        </template>
    </BaseModal>
</template>

<script>
import BaseButton from './redesigned/BaseButton'
import BaseCard from './redesigned/BaseCard'
import BaseModal from './redesigned/BaseModal'
import ChangePasswordForm from './ChangePasswordForm'

export default {
    name: 'ChangePasswordModal',
    components: {
        BaseButton,
        BaseCard,
        BaseModal,
        ChangePasswordForm,
    },
    data() {
        return {
            isDisabled: false,
            isLoading: false,
        }
    },
    methods: {
        handleSubmit() {
            this.$refs.form?.handleSubmit()
        },
    },
}
</script>

<i18n>
{
    "en": {
        "title": "Change password"
    },
    "de": {
        "title": "Passwort ändern"
    },
    "fr": {
        "title": "Modifier le mot de passe"
    },
    "it": {
        "title": "Modificare Password"
    }
}
</i18n>
